import React, { useState, useEffect } from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { getImage } from "../../contentful/data-provider";

export default function HoverBoxesSection(props) {
	const { content } = props;

	const [activeTab, setActiveTab] = useState(0);

	useEffect(() => {
		const handleMouseEnter = (e) => {
			let tab = e.target.getAttribute("data-tab");
			setActiveTab(parseInt(tab, 10));
		};
		let tabs = document.getElementsByClassName("tab");
		for (let tab of tabs) {
			tab.addEventListener("mouseenter", handleMouseEnter);
		}
		return () => {
			for (let tab of tabs) {
				tab.removeEventListener("mouseenter", handleMouseEnter);
			}
		};
	}, []);

	return (
		<>
			<section className='learn' key={content.id}>
				<div className='container'>
					<div className='row learn--header section--header'>
						<div className='col-lg-6'>
							<h2>{content.title}</h2>
						</div>
						<div className='subline col-lg-6'>{renderRichText(content.body)}</div>
					</div>
					<div className='row learn--content'>
						<div className='col-lg-6'>
							{content.elements.map((element, index) => {
								return (
									activeTab === index && (
										<div key={index} className={`box-image ${index === activeTab && "show"}`}>
											<img src={getImage(element.image).url} alt={getImage(element.image).title} />
										</div>
									)
								);
							})}
						</div>
						<div className='col-lg-5 offset-lg-1'>
							<div className='boxes'>
								{content.elements.map((element, index) => {
									return (
										<div
											key={index}
											data-tab={index}
											className={`tab boxes__box ${index === activeTab && "hover"}`}
											data-box={index}
										>
											<div className='decorate-container'>
												<div className='decorate'>
													<span className='decorate__item' />
													<span className='decorate__item' />
												</div>
											</div>
											<h3>{element.title}</h3>
											{renderRichText(element.body)}
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}
